import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import TabBase from '@material-ui/core/Tab';

const Tab = (props) => {
    const classes = useStyles();
    return (
        <TabBase
            className={classes.Tab}
            value={props.value}
            label={props.label}
            to={props.linkto}
            component={NavLink}
        />
    )
}

export default Tab;

const useStyles = makeStyles((theme) => ({
    Tab: {
        fontSize: "inherit",
        fontWeight: "700",
        padding: "10px 3.5vw",
        minWidth: "initial",
        color: theme.palette.text.primary,
        opacity: 1,
        "&:hover": {
            color: theme.palette.text.secondary,
            "& .tabmenu": {
                display: "block"
            }
        },
        "&.active": {
            color: theme.palette.primary.main
        }
    },
    [theme.breakpoints.up('md')]: {
        Tab: {
            padding: "10px 20px"
        }
    }
}));
